import { store } from "../../../redux/store";
import { loginURL } from "apiManager/APIConfig";
import { CallAPI } from "../../../apiManager/ApiCall";
import { setAuth } from "../../../redux/slices/authSlice";
import { userURL } from "apiManager/APIConfig";
import { setAllUsers } from "../../../redux/slices/userSlice";

import {
  GetVerifyUserAddedManuallyPurchaseCall,
  GetVerifyUserPurchaseCall,
} from "../transaction.api";

export const LoginCall = async (body) => {
  try {
    let response = await CallAPI({ url: loginURL, method: "POST", body });
    const platform =
      !response?.platform || response?.platform === "android"
        ? "android"
        : "ios";

    if (response?.access_token && response?.role == "admin") {
      store.dispatch(setAuth(response));
      return response;
    }
    const responseVerification = await GetVerifyUserPurchaseCall(
      platform,
      response?.access_token,
      response?.id
    );
    const responseVerificationAddedManually =
      await GetVerifyUserAddedManuallyPurchaseCall(
        platform,
        response?.access_token,
        response?.id
      );
    if (
      responseVerification?.isActive &&
      responseVerification?.identifier?.toLowerCase()?.includes("annual")
    ) {
      store.dispatch(setAuth(response));
      return response;
    } else if (
      responseVerificationAddedManually?.isActive &&
      responseVerificationAddedManually?.identifier
        ?.toLowerCase()
        ?.includes("annual")
    ) {
      store.dispatch(setAuth(response));
      return response;
    } else {
      response.status = 404;
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

export const GetAllUsersCall = async ({
  limit = 10,
  page = 1,
  search = "",
}) => {
  try {
    const response = await CallAPI({
      url: search
        ? `${userURL}?limit=${limit}&page=${page}&search=${search}`
        : `${userURL}?limit=${limit}&page=${page}`,
      method: "GET",
    });

    if (response) {
      store.dispatch(setAllUsers(response));
      return response;
    } else {
      return [];
    }
  } catch (error) {
    return { status: 400 };
  }
};
